import React from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import layout from "../../assets/img/about_layout.png";
import "./AboutUAIC.css";

const AboutUAIC = ({ responsiveStatus }) => {
  return (
    <div
      style={{
        ...(responsiveStatus === "isDesktop"
          ? styles.container
          : responsiveStatus === "isTablet" ||
            responsiveStatus === "isTabletLandscape"
          ? styles.container
          : styles.containerM),
        maxWidth: "1350px",
        margin: "0 auto",
      }}
      className="py-5"
    >
      {responsiveStatus === "isMobile" ||
      responsiveStatus === "isSmallMobile" ? (
        <p
          className={`${
            responsiveStatus ? "fw-bold fw-bold-m mb-3" : "fw-bold mb-3"
          }`}
          style={{
            fontSize:
              responsiveStatus === "isDesktop"
                ? "25px"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "25px"
                : "16px",

            textAlign:
              responsiveStatus === "isDesktop"
                ? "center"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "center"
                : "left",

            marginLeft: "12px",
          }}
        >
          <span
            style={{
              borderBottom: "2px solid #0E72D6",
              paddingBottom: "8px",
            }}
          >
            About UAIC
          </span>
        </p>
      ) : (
        <p
          className={`${
            responsiveStatus === "isDesktop"
              ? "fw-bold mb-3"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "fw-bold mb-3"
              : "fw-bold fw-bold-m mb-3"
          }`}
          style={{
            fontSize:
              responsiveStatus === "isDesktop"
                ? "25px"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "25px"
                : "16px",
            textAlign:
              responsiveStatus === "isDesktop"
                ? "center"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "center"
                : "left",
          }}
        >
          A
          <span
            style={{
              borderBottom: "2px solid #0E72D6",
              paddingBottom: "11px",
            }}
          >
            bout UA
          </span>
          IC
        </p>
      )}
      <div className="row align-items-center">
        {/* Image Section */}
        <div className="col-md-5 text-center position-relative mb-4 mb-md-0">
          <div className="position-relative d-inline-block">
            <img
              src={require("../../assets/img/uaic-building.svg")}
              alt="UAIC"
              className="img-fluid"
              style={{
                width: "100%",
                maxWidth:
                  responsiveStatus === "isDesktop"
                    ? "350px"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "350px"
                    : "260px",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "22%",
                left: "24%",
                transform: "translateX(-58%)",
                background: "#fff",
                padding: "5px",
                borderTopRightRadius: "30px",
                borderBottomLeftRadius: "30px",
                width:
                  responsiveStatus === "isDesktop"
                    ? "50%"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "50%"
                    : "54%",

                height:
                  responsiveStatus === "isDesktop"
                    ? "69px"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "69px"
                    : "56px",
              }}
            >
              {responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile" ? (
                <FloatingLabelM
                  text="Years of Excellence"
                  top="6%"
                  left="50%"
                />
              ) : (
                <FloatingLabel text="Years of Excellence" top="6%" left="50%" />
              )}
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div
          className={`${
            responsiveStatus === "isDesktop"
              ? "col-md-7 pl-5"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "col-md-7 pl-5"
              : "col-md-7"
          }`}
        >
          {/* <h5 className="fw-bold mb-3"></h5> */}
          <span
            className="fw-bold mb-3"
            style={{ fontSize: "1.25rem", lineHeight: "1.2", display: "block" }}
          >
            Delivering optimal insurance solutions to customers
          </span>
          <p className="text-muted">
            The company’s advancements in technology have been a catapult to our
            evolution. Our web technology and innovation is rated year after
            year as the most user-friendly and dependable by our agents. Our
            ongoing efforts to invest substantial resources in personnel and
            technology are the foundation to our promise of assuring maximum
            efficiency and specialized operations in the industry.
          </p>
          <Link className="text-dark btn-primary-button" to="/uaichome/aboutus">
            <span className="btn btn-primary-buttons-about mt-3">
              Read More
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    justifyContent: "center",
  },
  containerM: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    justifyContent: "left",
  },
};

export default AboutUAIC;

const FloatingLabel = ({ icon, text, top, left }) => (
  <div
    style={{
      position: "absolute",
      top,
      left,
      transform: "translateX(-50%)",
      background: "#fff",
      border: "1px solid #007bff",
      borderTopRightRadius: "30px",
      borderBottomLeftRadius: "30px",
      //   borderBottomRightRadius: '30px',
      padding: "8px 14px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      width: "165px",
    }}
  >
    <div
      style={{
        // backgroundColor: '#e6f0ff',
        borderRadius: "50%",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "26px",
        height: "30px",
      }}
    >
      <span
        style={{
          color: "#0E72D6",
          fontSize: "30px",
          fontWeight: 600,
          marginLeft: "18px",
        }}
      >
        35
      </span>
    </div>
    <span
      style={{
        fontWeight: 600,
        fontSize: "14px",
        color: "#000",
        textAlign: "left",
        marginLeft: "25px",
      }}
    >
      {text}
    </span>
  </div>
);
const FloatingLabelM = ({ icon, text, top, left }) => (
  <div
    style={{
      position: "absolute",
      top,
      left,
      transform: "translateX(-50%)",
      background: "#fff",
      border: "1px solid #007bff",
      borderTopRightRadius: "30px",
      borderBottomLeftRadius: "30px",
      //   borderBottomRightRadius: '30px',
      padding: "8px 14px",
      display: "flex",
      alignItems: "center",
      gap: "0px",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      width: "130px",
    }}
  >
    <div
      style={{
        // backgroundColor: '#e6f0ff',
        borderRadius: "50%",
        padding: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "26px",
        height: "30px",
      }}
    >
      <span
        style={{
          color: "#0E72D6",
          fontSize: "30px",
          fontWeight: 600,
          marginLeft: "10px",
        }}
      >
        35
      </span>
    </div>
    <span
      style={{
        fontWeight: 600,
        fontSize: "10px",
        color: "#000",
        textAlign: "left",
        marginLeft: "25px",
      }}
    >
      {text}
    </span>
  </div>
);
